import { render, staticRenderFns } from "./IdeasoftChannels.vue?vue&type=template&id=6f6fca1d&scoped=true"
import script from "./IdeasoftChannels.vue?vue&type=script&lang=js"
export * from "./IdeasoftChannels.vue?vue&type=script&lang=js"
import style0 from "./IdeasoftChannels.vue?vue&type=style&index=0&id=6f6fca1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6fca1d",
  null
  
)

export default component.exports